import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex justify-center w-full mt-32 pl-[10%] pr-[10%]" };
import UForm from "@/components/uikit/uComponents/uForm/UForm.vue";
import i18n from "@/localization/localization";
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useToast } from "vue-toastification";
import { useUser } from "@/composables/useAuth";
import AxiosController from "@/api/axiosController";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OAuth',
    setup(__props) {
        const t = (key, params) => i18n.global.t(key, params);
        const axiosController = new AxiosController();
        const toast = useToast();
        const user = useUser();
        const route = useRoute();
        const router = useRouter();
        const platform = process.env.VUE_APP_PLATFORM;
        const loading = ref(false);
        const appId = route.query.appId;
        if (!appId) {
            router.push({ path: "/" });
        }
        if (!user?.id) {
            router.push({ name: "login", query: { appId } });
        }
        async function auth() {
            try {
                loading.value = true;
                const params = await axiosController.getOAuthParams(appId);
                if (params.token) {
                    window.location.href = `${params.redirect_url}?token=${params.token}&refreshToken=${params.refresh_token}`;
                }
            }
            catch (error) {
                toast.error("Server error during the request");
                console.error(error);
                loading.value = false;
            }
        }
        return (_ctx, _cache) => {
            const _component_UButton = _resolveComponent("UButton");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(UForm, null, {
                    header: _withCtx(() => [
                        _createTextVNode(_toDisplayString(t("oauth.form.header", { platform: _unref(platform) })), 1)
                    ]),
                    submit: _withCtx(() => [
                        _createVNode(_component_UButton, {
                            loading: loading.value,
                            onClick: auth
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(t("oauth.form.button", {})), 1)
                            ]),
                            _: 1
                        }, 8, ["loading"])
                    ]),
                    default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(t("oauth.form.body", { platform: _unref(platform) })), 1)
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
